"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Field_1 = require("../Field");
var styles_1 = require("./styles");
var OptionalGroupInput = function (_a) {
    var ariaLabel = _a.ariaLabel, id = _a.id, children = _a.children, props = __rest(_a, ["ariaLabel", "id", "children"]);
    var handleKeyPress = function (e) {
        e.persist();
        if (e.currentTarget === document.activeElement) {
            props.onChange(!props.value);
        }
    };
    return (react_1.default.createElement(Field_1.Field, { id: id, required: props.required, error: props.error, hint: props.hint },
        react_1.default.createElement(styles_1.Wrapper, { "data-component-name": "OptionalGroupInput", id: id, onBlur: props.onBlur, tabIndex: props.disabled ? undefined : 0, onKeyPress: handleKeyPress },
            react_1.default.createElement(styles_1.Trigger, { onClick: props.disabled ? undefined : function () { return props.onChange(!props.value); } },
                props.label,
                react_1.default.createElement("div", null, props.value ? 'Remove' : 'Add')),
            props.value && react_1.default.createElement(styles_1.Fields, null, children))));
};
exports.default = OptionalGroupInput;
